import { useMemo } from "react";
import { Link } from "react-router-dom";
import { NavigationMenuItem } from "@idw-types/common";
import { NavigationMenuListItemContent } from "../navigation-menu-list-item-content/navigation-menu-list-item-content";
import styles from "./navigation-menu-list-item.less";

type NavigationMenuListItemProps = {
    collapsedHorizontally: boolean;
    item: NavigationMenuItem;
    expanded: boolean;
    depthLevel: number;
    onListItemClick?: () => void;
};

export const NavigationMenuListItem = (props: NavigationMenuListItemProps) => {
    const { collapsedHorizontally, item, expanded, depthLevel, onListItemClick } = props;

    const depthClassName = useMemo(() => {
        if (depthLevel === 0) {
            return "";
        } else if (depthLevel === 1) {
            return styles.depthLevelOne;
        } else if (depthLevel === 2) {
            return styles.depthLevelTwo;
        }
    }, [depthLevel]);

    const selectedClassName = useMemo(() => {
        if (window.location.pathname === item.path || window.location.pathname === `/axnadmin${item.path}`) {
            return styles.selected;
        } else {
            return "";
        }
    }, [window.location.pathname]);

    return (
        <li
            id={`navigation-menu-list-item-${item.idSuffix}`}
            title={item.title}
            className={`${styles.navigationMenuListItem} ${depthClassName} ${selectedClassName}`}
            onClick={onListItemClick}
        >
            {item.path && !item.isExternalUrl && (
                <Link to={item.path} className={styles.contentContainer}>
                    <NavigationMenuListItemContent collapsedHorizontally={collapsedHorizontally} item={item} expanded={expanded} />
                </Link>
            )}
            {item.path && item.isExternalUrl && (
                <a href={item.path} className={styles.contentContainer}>
                    <NavigationMenuListItemContent collapsedHorizontally={collapsedHorizontally} item={item} expanded={expanded} />
                </a>
            )}
            {!item.path && (
                <button className={styles.contentContainer}>
                    <NavigationMenuListItemContent collapsedHorizontally={collapsedHorizontally} item={item} expanded={expanded} />
                </button>
            )}
        </li>
    );
};